import AsyncStorage from '@react-native-async-storage/async-storage';
let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
 
import React, { useState, useEffect, useRef } from 'react';

import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';

import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  SafeAreaView,
  StatusBar,
  Image,
  FlatList,
  Animated,
  ActivityIndicator,
  Alert,
  Modal,
  TextInput,
  Dimensions,
  RefreshControl,
} from 'react-native';
import {
  Ionicons,
  MaterialIcons,
  FontAwesome5,
  MaterialCommunityIcons,
  AntDesign,
  Feather,
} from '@expo/vector-icons';
import { useFocusEffect } from '@react-navigation/native';
import portfolioDatabase from '../../services/PortfolioDatabase';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
const apiFetch = async (endpoint, options = {}) => {
  try {
    const response = await fetch(`${API_BASE}${endpoint}`, {
      headers: { 'Content-Type': 'application/json', 'x-api-key': API_KEY },
      ...options,
    });
    if (!response.ok) return { error: true, status: response.status };
    return await response.json();
  } catch (err) { return { error: true, message: err.message }; }
};




const { width, height } = Dimensions.get('window');

// JOBENG Logo component
const JobengLogo = () => (
  <Image
    source={require('../../../assets/jobeng_icon.png')}
    style={{ width: 30, height: 30 }}
    resizeMode="contain"
  />
);

export default function SkillAssessmentScreen({ navigation, route }) {
  // === Live API Data ===
  const [userId, setUserId] = React.useState('default');
  React.useEffect(() => {
    AsyncStorage.getItem('userToken').then(t => { if (t) setUserId(t.slice(0, 16)); }).catch(() => {});
  }, []);
  React.useEffect(() => {
    if (userId === 'default') return;
    const _ck = `professional_${_profUserId}_skillassessmentscreen`;
    apiFetch('/api/data/assessments?sort=created_at&order=desc&limit=20').then(d => {
      if (d && !d.error) {
        const arr = Array.isArray(d) ? d : (d.data || d.results || []);
        AsyncStorage.setItem(_ck, JSON.stringify(arr)).catch(() => {});
      }
    }).catch(() => {});
  }, [userId]);

  // Main states
  const [isLoading, setIsLoading] = useState(true);
  const [course, setCourse] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [isAssessmentComplete, setIsAssessmentComplete] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [score, setScore] = useState(0);
  const [error, setError] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  
  // Portfolio integration states
  const [portfolioData, setPortfolioData] = useState(null);
  const [userSkills, setUserSkills] = useState([]);
  const [assessmentHistory, setAssessmentHistory] = useState([]);
  
  // Code input state for code questions
  const [codeInput, setCodeInput] = useState('');
  
  // Enhanced states
  const [showExplanation, setShowExplanation] = useState(false);
  const [currentExplanation, setCurrentExplanation] = useState('');
  const [assessmentStarted, setAssessmentStarted] = useState(false);
  const [showInstructions, setShowInstructions] = useState(true);

  // Animation values
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const slideAnim = useRef(new Animated.Value(50)).current;
  const scaleAnim = useRef(new Animated.Value(0.9)).current;

  // Timer ref
  const timerRef = useRef(null);

  // Enhanced mock data with portfolio integration
  const mockCourses = [
    {
      id: '1',
      title: 'Technical Interview Preparation',
      provider: 'JobEng Academy',
      description: 'Master technical interviews with comprehensive practice questions and real-world scenarios.',
      difficulty: 'Intermediate',
      estimatedTime: '20 minutes',
      skillsRequired: ['JavaScript', 'Data Structures', 'Algorithms', 'Problem Solving'],
      assessment: {
        timeLimit: 20, // minutes
        passingScore: 70,
        totalQuestions: 8,
        questions: [
          {
            id: 'q1',
            type: 'multiple-choice',
            question: 'Which data structure would be most efficient for implementing a priority queue?',
            options: ['Array', 'Linked List', 'Heap', 'Hash Table'],
            correctAnswer: 2, // Heap (0-indexed)
            explanation: 'A heap is the most efficient data structure for a priority queue as it provides O(log n) time complexity for both insertion and deletion of the highest-priority element.',
            difficulty: 'Medium',
            category: 'Data Structures',
          },
          {
            id: 'q2',
            type: 'multiple-choice',
            question: 'What is the time complexity of the quicksort algorithm in the average case?',
            options: ['O(n)', 'O(n log n)', 'O(n²)', 'O(log n)'],
            correctAnswer: 1, // O(n log n)
            explanation: 'Quicksort has an average time complexity of O(n log n), making it one of the most efficient sorting algorithms for large datasets.',
            difficulty: 'Medium',
            category: 'Algorithms',
          },
          {
            id: 'q3',
            type: 'multiple-choice',
            question: 'Which of the following is NOT a principle of object-oriented programming?',
            options: ['Encapsulation', 'Inheritance', 'Normalization', 'Polymorphism'],
            correctAnswer: 2, // Normalization
            explanation: 'Normalization is a concept in database design, not a principle of object-oriented programming. The principles of OOP are encapsulation, inheritance, polymorphism, and abstraction.',
            difficulty: 'Easy',
            category: 'Programming Concepts',
          },
          {
            id: 'q4',
            type: 'true-false',
            question: 'In a binary search tree, the left child is always less than the parent node.',
            options: ['True', 'False'],
            correctAnswer: 0, // True
            explanation: 'In a binary search tree, the left child is always less than the parent node, and the right child is always greater than the parent node.',
            difficulty: 'Easy',
            category: 'Data Structures',
          },
          {
            id: 'q5',
            type: 'multiple-choice',
            question: 'What design pattern is best suited for creating objects without specifying their concrete classes?',
            options: ['Singleton', 'Factory', 'Observer', 'Decorator'],
            correctAnswer: 1, // Factory
            explanation: 'The Factory design pattern is used to create objects without specifying the exact class of object that will be created, allowing for flexibility in object creation.',
            difficulty: 'Medium',
            category: 'Design Patterns',
          },
          {
            id: 'q6',
            type: 'code',
            question: 'Write a JavaScript function that reverses a string without using built-in reverse methods.',
            correctAnswer: 'function reverseString(str) {\n  let reversed = "";\n  for (let i = str.length - 1; i >= 0; i--) {\n    reversed += str[i];\n  }\n  return reversed;\n}',
            explanation: 'This function iterates through the string from the last character to the first, building a new string in reverse order.',
            difficulty: 'Easy',
            category: 'Programming',
          },
          {
            id: 'q7',
            type: 'multiple-choice',
            question: 'Which HTTP status code indicates that a resource was successfully created?',
            options: ['200 OK', '201 Created', '204 No Content', '301 Moved Permanently'],
            correctAnswer: 1, // 201 Created
            explanation: '201 Created indicates that the request has been fulfilled and resulted in a new resource being created.',
            difficulty: 'Easy',
            category: 'Web Development',
          },
          {
            id: 'q8',
            type: 'multiple-choice',
            question: 'In React, what is the purpose of the useEffect hook?',
            options: [
              'To manage component state',
              'To handle side effects in functional components',
              'To create reusable components',
              'To optimize component rendering'
            ],
            correctAnswer: 1, // To handle side effects
            explanation: 'useEffect is used to handle side effects in functional components, such as data fetching, subscriptions, or manually changing the DOM.',
            difficulty: 'Medium',
            category: 'React',
          },
        ],
      },
    },
    {
      id: '2',
      title: 'Python for Data Analysis',
      provider: 'DataCamp',
      description: 'Learn essential Python skills for data manipulation, analysis, and visualization.',
      difficulty: 'Beginner',
      estimatedTime: '30 minutes',
      skillsRequired: ['Python', 'Data Analysis', 'Pandas', 'NumPy'],
      assessment: {
        timeLimit: 30, // minutes
        passingScore: 70,
        totalQuestions: 6,
        questions: [
          {
            id: 'q1',
            type: 'multiple-choice',
            question: 'Which Python library is primarily used for data manipulation and analysis?',
            options: ['NumPy', 'Matplotlib', 'Pandas', 'Scikit-learn'],
            correctAnswer: 2, // Pandas
            explanation: 'Pandas is specifically designed for data manipulation and analysis, providing data structures like DataFrame and Series that are optimized for these tasks.',
            difficulty: 'Easy',
            category: 'Python Libraries',
          },
          {
            id: 'q2',
            type: 'multiple-choice',
            question: 'What function would you use to handle missing values in a pandas DataFrame?',
            options: ['df.missing()', 'df.fillna()', 'df.dropna()', 'Both B and C'],
            correctAnswer: 3, // Both fillna() and dropna()
            explanation: 'Both fillna() and dropna() are used to handle missing values in pandas. fillna() replaces missing values with a specified value, while dropna() removes rows or columns with missing values.',
            difficulty: 'Medium',
            category: 'Data Cleaning',
          },
          {
            id: 'q3',
            type: 'code',
            question: 'Write a Python function that uses pandas to read a CSV file named "data.csv" and returns the first 5 rows.',
            correctAnswer: 'import pandas as pd\n\ndef read_csv_data():\n    df = pd.read_csv("data.csv")\n    return df.head()',
            explanation: 'This function uses pandas to read a CSV file and returns the first 5 rows using the head() method.',
            difficulty: 'Easy',
            category: 'File Operations',
          },
          {
            id: 'q4',
            type: 'multiple-choice',
            question: 'Which of the following is NOT a valid way to select a column in a pandas DataFrame?',
            options: ['df["column_name"]', 'df.column_name', 'df.get("column_name")', 'df.loc[:, "column_name"]'],
            correctAnswer: 2, // df.get("column_name")
            explanation: 'df.get("column_name") is not a standard pandas method for column selection. The valid ways are df["column_name"], df.column_name (for valid Python identifiers), and df.loc[:, "column_name"].',
            difficulty: 'Medium',
            category: 'DataFrame Operations',
          },
          {
            id: 'q5',
            type: 'true-false',
            question: 'In pandas, the apply() function can be used to apply a function along an axis of a DataFrame.',
            options: ['True', 'False'],
            correctAnswer: 0, // True
            explanation: 'The apply() function in pandas allows you to apply a function along an axis (rows or columns) of a DataFrame, making it a powerful tool for data transformation.',
            difficulty: 'Medium',
            category: 'Data Transformation',
          },
          {
            id: 'q6',
            type: 'multiple-choice',
            question: 'What is the primary purpose of NumPy in data analysis?',
            options: [
              'Web scraping',
              'Numerical computing with arrays',
              'Database connections',
              'GUI development'
            ],
            correctAnswer: 1, // Numerical computing with arrays
            explanation: 'NumPy provides support for large, multi-dimensional arrays and matrices, along with mathematical functions to operate on these arrays efficiently.',
            difficulty: 'Easy',
            category: 'NumPy',
          },
        ],
      },
    },
    {
      id: '3',
      title: 'JavaScript Fundamentals',
      provider: 'JobEng Academy',
      description: 'Test your knowledge of core JavaScript concepts and modern ES6+ features.',
      difficulty: 'Beginner',
      estimatedTime: '25 minutes',
      skillsRequired: ['JavaScript', 'ES6+', 'DOM Manipulation', 'Async Programming'],
      assessment: {
        timeLimit: 25,
        passingScore: 75,
        totalQuestions: 7,
        questions: [
          {
            id: 'q1',
            type: 'multiple-choice',
            question: 'What is the difference between let and var in JavaScript?',
            options: [
              'No difference',
              'let has block scope, var has function scope',
              'var has block scope, let has function scope',
              'let is faster than var'
            ],
            correctAnswer: 1,
            explanation: 'let has block scope while var has function scope. This means let variables are only accessible within the block they are declared in.',
            difficulty: 'Medium',
            category: 'Variables',
          },
          {
            id: 'q2',
            type: 'code',
            question: 'Write a JavaScript arrow function that takes an array of numbers and returns the sum.',
            correctAnswer: 'const sumArray = (numbers) => numbers.reduce((sum, num) => sum + num, 0);',
            explanation: 'This arrow function uses the reduce method to sum all numbers in the array, starting with an initial value of 0.',
            difficulty: 'Medium',
            category: 'Functions',
          },
          {
            id: 'q3',
            type: 'true-false',
            question: 'JavaScript is a statically typed language.',
            options: ['True', 'False'],
            correctAnswer: 1, // False
            explanation: 'JavaScript is a dynamically typed language, meaning variable types are determined at runtime.',
            difficulty: 'Easy',
            category: 'Language Features',
          },
          {
            id: 'q4',
            type: 'multiple-choice',
            question: 'Which method is used to add an element to the end of an array?',
            options: ['append()', 'push()', 'add()', 'insert()'],
            correctAnswer: 1, // push()
            explanation: 'The push() method adds one or more elements to the end of an array and returns the new length of the array.',
            difficulty: 'Easy',
            category: 'Arrays',
          },
          {
            id: 'q5',
            type: 'multiple-choice',
            question: 'What does the async/await syntax do in JavaScript?',
            options: [
              'Makes code run faster',
              'Handles asynchronous operations more readably',
              'Creates new threads',
              'Compiles code to machine language'
            ],
            correctAnswer: 1,
            explanation: 'async/await provides a more readable way to handle asynchronous operations, making asynchronous code look and behave more like synchronous code.',
            difficulty: 'Medium',
            category: 'Async Programming',
          },
          {
            id: 'q6',
            type: 'multiple-choice',
            question: 'Which of the following is NOT a primitive data type in JavaScript?',
            options: ['string', 'number', 'object', 'boolean'],
            correctAnswer: 2, // object
            explanation: 'object is not a primitive data type. The primitive types in JavaScript are: string, number, boolean, undefined, null, symbol, and bigint.',
            difficulty: 'Medium',
            category: 'Data Types',
          },
          {
            id: 'q7',
            type: 'code',
            question: 'Write a JavaScript function that checks if a string is a palindrome (reads the same forwards and backwards).',
            correctAnswer: 'function isPalindrome(str) {\n  const cleaned = str.toLowerCase().replace(/[^a-z0-9]/g, "");\n  return cleaned === cleaned.split("").reverse().join("");\n}',
            explanation: 'This function cleans the string by converting to lowercase and removing non-alphanumeric characters, then compares it with its reverse.',
            difficulty: 'Medium',
            category: 'String Manipulation',
          },
        ],
      },
    },
  ];

  // Load data on component mount and focus
  useEffect(() => {
    initializeScreen();
  }, []);

  useFocusEffect(
    React.useCallback(() => {
      loadPortfolioData();
    }, [])
  );

  const initializeScreen = async () => {
    try {
      setIsLoading(true);
      
      // Initialize portfolio database
      await portfolioDatabase.initialize();
      
      // Load portfolio and assessment data
      await Promise.all([
        loadPortfolioData(),
        loadAssessmentData()
      ]);
      
      // Start animations
      startAnimations();
      
    } catch (error) {
      console.error('❌ Error initializing skill assessment screen:', error);
      setError('Failed to initialize assessment');
    } finally {
      setIsLoading(false);
    }
  };

  const loadPortfolioData = async () => {
    try {
      console.log('🔄 Loading portfolio data for skill assessment...');
      
      // Load portfolio data
      const [profile, skills] = await Promise.all([
        portfolioDatabase.getProfile(),
        portfolioDatabase.getSkills()
      ]);

      setPortfolioData({ profile: profile || {}, skills: skills || [] });
      setUserSkills(skills || []);
      
      console.log('✅ Portfolio data loaded for skill assessment');
      
    } catch (error) {
      console.error('❌ Error loading portfolio data:', error);
    }
  };

  const loadAssessmentData = async () => {
    try {
      console.log('🔄 Loading assessment data...');
      
      // Get course ID from route params with null safety
      const courseId = route?.params?.courseId;
      
      if (!courseId) {
        setError('No course ID provided');
        return;
      }

      // Find course with null safety
      const foundCourse = mockCourses.find(c => c && c.id === courseId);

      if (foundCourse && foundCourse.assessment && foundCourse.assessment.questions) {
        setCourse(foundCourse);
        setTimeRemaining(foundCourse.assessment.timeLimit * 60); // Convert minutes to seconds
        setError(null);
        console.log('✅ Assessment data loaded successfully');
      } else {
        setError('Assessment not found for this course');
        console.warn('⚠️ Course or assessment not found:', courseId);
      }
      
    } catch (error) {
      console.error('❌ Error loading assessment data:', error);
      setError('Failed to load assessment');
    }
  };

  const startAnimations = () => {
    Animated.parallel([
      Animated.timing(fadeAnim, {
        toValue: 1,
        duration: 800,
        useNativeDriver: true,
      }),
      Animated.timing(slideAnim, {
        toValue: 0,
        duration: 800,
        useNativeDriver: true,
      }),
      Animated.timing(scaleAnim, {
        toValue: 1,
        duration: 800,
        useNativeDriver: true,
      }),
    ]).start();
  };

  const onRefresh = async () => {
    setRefreshing(true);
    try {
      await Promise.all([
        loadPortfolioData(),
        loadAssessmentData()
      ]);
    } catch (error) {
      console.error('❌ Error refreshing:', error);
    } finally {
      setRefreshing(false);
    }
  };

  // Start timer when assessment begins
  useEffect(() => {
    if (course && timeRemaining !== null && !isAssessmentComplete && assessmentStarted) {
      timerRef.current = setInterval(() => {
        setTimeRemaining(prev => {
          if (prev <= 1) {
            clearInterval(timerRef.current);
            handleAssessmentComplete();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [course, isAssessmentComplete, assessmentStarted]);

  // Format time remaining
  const formatTime = seconds => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  // Handle answer selection with null safety
  const handleAnswerSelect = (questionId, answerIndex) => {
    if (!questionId) return;
    
    setAnswers(prev => ({
      ...prev,
      [questionId]: answerIndex,
    }));
  };

  // Handle code input
  const handleCodeInput = (questionId, code) => {
    if (!questionId) return;
    
    setCodeInput(code);
    setAnswers(prev => ({
      ...prev,
      [questionId]: code,
    }));
  };

  // Handle next question with null safety
  const handleNextQuestion = () => {
    if (!course || !course.assessment || !course.assessment.questions) return;
    
    if (currentQuestion < course.assessment.questions.length - 1) {
      setCurrentQuestion(prev => prev + 1);
      setCodeInput(''); // Reset code input for next question
    } else {
      setShowConfirmModal(true);
    }
  };

  // Handle previous question
  const handlePrevQuestion = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(prev => prev - 1);
      
      // Load previous code input if it exists
      if (course && course.assessment && course.assessment.questions) {
        const prevQuestion = course.assessment.questions[currentQuestion - 1];
        if (prevQuestion && prevQuestion.type === 'code' && answers[prevQuestion.id]) {
          setCodeInput(answers[prevQuestion.id]);
        }
      }
    }
  };

  // Start assessment
  const handleStartAssessment = () => {
    setAssessmentStarted(true);
    setShowInstructions(false);
  };

  // Handle assessment completion with null safety
  const handleAssessmentComplete = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    setIsAssessmentComplete(true);

    // Calculate score with null safety
    let correctAnswers = 0;
    let totalQuestions = 0;

    if (course && course.assessment && course.assessment.questions) {
      totalQuestions = course.assessment.questions.length;
      
      course.assessment.questions.forEach(question => {
        if (question && question.id && question.correctAnswer !== undefined) {
          if (question.type === 'code') {
            // For code questions, check if answer exists (simplified evaluation)
            if (answers[question.id] && answers[question.id].trim().length > 0) {
              correctAnswers++;
            }
          } else {
            // For multiple choice and true/false questions
            if (answers[question.id] === question.correctAnswer) {
              correctAnswers++;
            }
          }
        }
      });
    }

    const calculatedScore = totalQuestions > 0 ? Math.round((correctAnswers / totalQuestions) * 100) : 0;
    setScore(calculatedScore);

    // Save assessment result to portfolio
    saveAssessmentResult(calculatedScore, correctAnswers, totalQuestions);

    setShowResults(true);
  };

  // Save assessment result
  const saveAssessmentResult = async (score, correct, total) => {
    try {
      const assessmentResult = {
        id: `assessment_${Date.now()}`,
        courseId: course?.id,
        courseTitle: course?.title,
        score: score,
        correctAnswers: correct,
        totalQuestions: total,
        passed: course?.assessment ? score >= course.assessment.passingScore : false,
        completedAt: new Date().toISOString(),
        timeSpent: course?.assessment ? (course.assessment.timeLimit * 60) - timeRemaining : 0,
      };

      // Save to portfolio database (if method exists)
      if (portfolioDatabase && typeof portfolioDatabase.saveAssessmentResult === 'function') {
        await portfolioDatabase.saveAssessmentResult(assessmentResult);
      }

      // Mirror into ProfileManagementService so the score shows up in ProfileScreen
      // stats and in cross-screen recommendations.
      try {
        await ProfileManagementService.bootstrap();
        await ProfileManagementService.saveSkillAssessment({
          skill_name: course?.title || 'Assessment',
          course_id: course?.id,
          score,
          correct_answers: correct,
          total_questions: total,
          passed: assessmentResult.passed,
          completed_at: assessmentResult.completedAt,
          time_spent_seconds: assessmentResult.timeSpent,
        });
      } catch (_) {}

      console.log('✅ Assessment result saved:', assessmentResult);
    } catch (error) {
      console.error('❌ Error saving assessment result:', error);
    }
  };

  // Show explanation
  const showQuestionExplanation = (explanation) => {
    setCurrentExplanation(explanation);
    setShowExplanation(true);
  };

  // Handle continue to skill progress
  const handleContinueToProgress = () => {
    const isPassed = course?.assessment ? score >= course.assessment.passingScore : false;
    
    navigation.navigate('SkillProgress', {
      courseId: course?.id,
      score: score,
      isPassed: isPassed,
    });
  };

  // Handle retake assessment
  const handleRetakeAssessment = () => {
    // Reset all states
    setCurrentQuestion(0);
    setAnswers({});
    setCodeInput('');
    setIsAssessmentComplete(false);
    setShowResults(false);
    setScore(0);
    setAssessmentStarted(false);
    setShowInstructions(true);
    
    // Reset timer
    if (course?.assessment) {
      setTimeRemaining(course.assessment.timeLimit * 60);
    }
  };

  // Get skill match percentage
  const getSkillMatchPercentage = () => {
    if (!course?.skillsRequired || !userSkills || userSkills.length === 0) {
      return 0;
    }

    const matchingSkills = course.skillsRequired.filter(requiredSkill =>
      userSkills.some(userSkill => 
        userSkill.name && String(userSkill.name ?? '').toLowerCase().includes(requiredSkill.toLowerCase())
      )
    );

    return Math.round((matchingSkills.length / course.skillsRequired.length) * 100);
  };

  // Render loading state
  const renderLoading = () => (
    <View style={styles.loadingContainer}>
      <ActivityIndicator size={36} color="#0e4e96" />
      <Text style={styles.loadingText}>Loading assessment...</Text>
    </View>
  );

  // Render error state
  const renderError = () => (
    <View style={styles.errorContainer}>
      <Ionicons name="alert-circle-outline" size={60} color="#EF4444" />
      <Text style={styles.errorTitle}>Error</Text>
      <Text style={styles.errorMessage}>{error}</Text>
      <TouchableOpacity
        style={styles.errorButton}
        onPress={() => navigation.goBack()}
      >
        <Text style={styles.errorButtonText}>Go Back</Text>
      </TouchableOpacity>
    </View>
  );

  // Render instructions screen
  const renderInstructions = () => (
    <ScrollView 
      style={styles.instructionsContainer}
      refreshControl={
        <RefreshControl
          refreshing={refreshing}
          onRefresh={onRefresh}
          colors={['#0e4e96']}
          tintColor="#0e4e96"
        />
      }
    >
      <View style={styles.instructionsContent}>
        <View style={styles.courseHeader}>
          <View style={styles.courseInfo}>
            <Text style={styles.courseTitle}>{course?.title}</Text>
            <Text style={styles.courseProvider}>by {course?.provider}</Text>
            <Text style={styles.courseDescription}>{course?.description}</Text>
          </View>
          
          <View style={styles.courseMeta}>
            <View style={styles.metaItem}>
              <Ionicons name="time-outline" size={16} color="#64748B" />
              <Text style={styles.metaText}>{course?.estimatedTime}</Text>
            </View>
            <View style={styles.metaItem}>
              <Ionicons name="bar-chart-outline" size={16} color="#64748B" />
              <Text style={styles.metaText}>{course?.difficulty}</Text>
            </View>
            <View style={styles.metaItem}>
              <Ionicons name="help-circle-outline" size={16} color="#64748B" />
              <Text style={styles.metaText}>{course?.assessment?.totalQuestions} Questions</Text>
            </View>
          </View>
        </View>

        {/* Portfolio Integration */}
        {portfolioData && (
          <View style={styles.portfolioSection}>
            <Text style={styles.sectionTitle}>Your Skill Match</Text>
            <View style={styles.skillMatchCard}>
              <View style={styles.skillMatchHeader}>
                <Text style={styles.skillMatchPercentage}>{getSkillMatchPercentage()}%</Text>
                <Text style={styles.skillMatchLabel}>Match</Text>
              </View>
              <Text style={styles.skillMatchDescription}>
                Based on your portfolio skills
              </Text>
            </View>
          </View>
        )}

        {/* Required Skills */}
        <View style={styles.skillsSection}>
          <Text style={styles.sectionTitle}>Skills Covered</Text>
          <View style={styles.skillsGrid}>
            {course?.skillsRequired?.map((skill, index) => {
              const hasSkill = userSkills.some(userSkill => 
                userSkill.name && String(userSkill.name ?? '').toLowerCase().includes(skill.toLowerCase())
              );
              
              return (
                <View 
                  key={index} 
                  style={[
                    styles.skillChip,
                    hasSkill && styles.skillChipMatched
                  ]}
                >
                  <Text style={[
                    styles.skillChipText,
                    hasSkill && styles.skillChipTextMatched
                  ]}>
                    {skill}
                  </Text>
                  {hasSkill && (
                    <Ionicons name="checkmark-circle" size={16} color="#10B981" />
                  )}
                </View>
              );
            })}
          </View>
        </View>

        {/* Assessment Details */}
        <View style={styles.assessmentDetails}>
          <Text style={styles.sectionTitle}>Assessment Details</Text>
          
          <View style={styles.detailsGrid}>
            <View style={styles.detailItem}>
              <Ionicons name="time-outline" size={24} color="#0e4e96" />
              <Text style={styles.detailLabel}>Time Limit</Text>
              <Text style={styles.detailValue}>{course?.assessment?.timeLimit} minutes</Text>
            </View>
            
            <View style={styles.detailItem}>
              <Ionicons name="help-circle-outline" size={24} color="#0e4e96" />
              <Text style={styles.detailLabel}>Questions</Text>
              <Text style={styles.detailValue}>{course?.assessment?.totalQuestions}</Text>
            </View>
            
            <View style={styles.detailItem}>
              <Ionicons name="trophy-outline" size={24} color="#0e4e96" />
              <Text style={styles.detailLabel}>Passing Score</Text>
              <Text style={styles.detailValue}>{course?.assessment?.passingScore}%</Text>
            </View>
          </View>
        </View>

        {/* Instructions */}
        <View style={styles.instructionsSection}>
          <Text style={styles.sectionTitle}>Instructions</Text>
          <View style={styles.instructionsList}>
            <View style={styles.instructionItem}>
              <View style={styles.instructionNumber}>
                <Text style={styles.instructionNumberText}>1</Text>
              </View>
              <Text style={styles.instructionText}>
                Read each question carefully before selecting your answer
              </Text>
            </View>
            
            <View style={styles.instructionItem}>
              <View style={styles.instructionNumber}>
                <Text style={styles.instructionNumberText}>2</Text>
              </View>
              <Text style={styles.instructionText}>
                You can navigate between questions using the Previous/Next buttons
              </Text>
            </View>
            
            <View style={styles.instructionItem}>
              <View style={styles.instructionNumber}>
                <Text style={styles.instructionNumberText}>3</Text>
              </View>
              <Text style={styles.instructionText}>
                The timer will start when you begin the assessment
              </Text>
            </View>
            
            <View style={styles.instructionItem}>
              <View style={styles.instructionNumber}>
                <Text style={styles.instructionNumberText}>4</Text>
              </View>
              <Text style={styles.instructionText}>
                Submit your assessment before time runs out
              </Text>
            </View>
          </View>
        </View>

        <TouchableOpacity
          style={styles.startAssessmentButton}
          onPress={handleStartAssessment}
        >
          <Text style={styles.startAssessmentButtonText}>Start Assessment</Text>
          <Ionicons name="arrow-forward" size={20} color="#fff" />
        </TouchableOpacity>
      </View>
    </ScrollView>
  );

  // Render multiple choice question
  const renderMultipleChoiceQuestion = question => (
    <View style={styles.questionContainer}>
      <View style={styles.questionHeader}>
        <View style={styles.questionMeta}>
          <View style={styles.categoryBadge}>
            <Text style={styles.categoryText}>{question.category}</Text>
          </View>
          <View style={styles.difficultyBadge}>
            <Text style={styles.difficultyText}>{question.difficulty}</Text>
          </View>
        </View>
      </View>
      
      <Text style={styles.questionText}>{question.question}</Text>

      {question.options?.map((option, index) => (
        <TouchableOpacity
          key={index}
          style={[
            styles.optionButton,
            answers[question.id] === index && styles.selectedOptionButton,
          ]}
          onPress={() => handleAnswerSelect(question.id, index)}
        >
          <View style={styles.optionContent}>
            <View
              style={[
                styles.optionIndicator,
                answers[question.id] === index && styles.selectedOptionIndicator,
              ]}
            >
              <Text
                style={[
                  styles.optionIndicatorText,
                  answers[question.id] === index && styles.selectedOptionIndicatorText,
                ]}
              >
                {String.fromCharCode(65 + index)}
              </Text>
            </View>
            <Text
              style={[
                styles.optionText,
                answers[question.id] === index && styles.selectedOptionText,
              ]}
            >
              {option}
            </Text>
          </View>
        </TouchableOpacity>
      ))}

      {question.explanation && (
        <TouchableOpacity
          style={styles.explanationButton}
          onPress={() => showQuestionExplanation(question.explanation)}
        >
          <Ionicons name="help-circle-outline" size={16} color="#0e4e96" />
          <Text style={styles.explanationButtonText}>View Explanation</Text>
        </TouchableOpacity>
      )}
    </View>
  );

  // Render true-false question
  const renderTrueFalseQuestion = question => (
    <View style={styles.questionContainer}>
      <View style={styles.questionHeader}>
        <View style={styles.questionMeta}>
          <View style={styles.categoryBadge}>
            <Text style={styles.categoryText}>{question.category}</Text>
          </View>
          <View style={styles.difficultyBadge}>
            <Text style={styles.difficultyText}>{question.difficulty}</Text>
          </View>
        </View>
      </View>
      
      <Text style={styles.questionText}>{question.question}</Text>

      <View style={styles.trueFalseContainer}>
        <TouchableOpacity
          style={[
            styles.trueFalseButton,
            answers[question.id] === 0 && styles.selectedTrueFalseButton,
            answers[question.id] === 0 ? styles.trueButton : {},
          ]}
          onPress={() => handleAnswerSelect(question.id, 0)}
        >
          <Ionicons
            name={answers[question.id] === 0 ? 'checkmark-circle' : 'checkmark-circle-outline'}
            size={24}
            color={answers[question.id] === 0 ? '#fff' : '#10B981'}
          />
          <Text
            style={[
              styles.trueFalseText,
              answers[question.id] === 0 && styles.selectedTrueFalseText,
            ]}
          >
            True
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={[
            styles.trueFalseButton,
            answers[question.id] === 1 && styles.selectedTrueFalseButton,
            answers[question.id] === 1 ? styles.falseButton : {},
          ]}
          onPress={() => handleAnswerSelect(question.id, 1)}
        >
          <Ionicons
            name={answers[question.id] === 1 ? 'close-circle' : 'close-circle-outline'}
            size={24}
            color={answers[question.id] === 1 ? '#fff' : '#EF4444'}
          />
          <Text
            style={[
              styles.trueFalseText,
              answers[question.id] === 1 && styles.selectedTrueFalseText,
            ]}
          >
            False
          </Text>
        </TouchableOpacity>
      </View>

      {question.explanation && (
        <TouchableOpacity
          style={styles.explanationButton}
          onPress={() => showQuestionExplanation(question.explanation)}
        >
          <Ionicons name="help-circle-outline" size={16} color="#0e4e96" />
          <Text style={styles.explanationButtonText}>View Explanation</Text>
        </TouchableOpacity>
      )}
    </View>
  );

  // Render code question
  const renderCodeQuestion = question => (
    <View style={styles.questionContainer}>
      <View style={styles.questionHeader}>
        <View style={styles.questionMeta}>
          <View style={styles.categoryBadge}>
            <Text style={styles.categoryText}>{question.category}</Text>
          </View>
          <View style={styles.difficultyBadge}>
            <Text style={styles.difficultyText}>{question.difficulty}</Text>
          </View>
        </View>
      </View>
      
      <Text style={styles.questionText}>{question.question}</Text>

      <View style={styles.codeInputContainer}>
        <TextInput
          style={styles.codeInput}
          value={codeInput}
          onChangeText={(text) => handleCodeInput(question.id, text)}
          placeholder="Write your code here..."
          placeholderTextColor="#94A3B8"
          multiline
          textAlignVertical="top"
        />
      </View>

      {question.explanation && (
        <TouchableOpacity
          style={styles.explanationButton}
          onPress={() => showQuestionExplanation(question.explanation)}
        >
          <Ionicons name="help-circle-outline" size={16} color="#0e4e96" />
          <Text style={styles.explanationButtonText}>View Explanation</Text>
        </TouchableOpacity>
      )}
    </View>
  );

  // Render current question based on type with null safety
  const renderQuestion = () => {
    if (!course || !course.assessment || !course.assessment.questions || !course.assessment.questions[currentQuestion]) {
      return (
        <View style={styles.errorContainer}>
          <Text style={styles.errorMessage}>Question not available</Text>
        </View>
      );
    }

    const question = course.assessment.questions[currentQuestion];

    switch (question.type) {
      case 'multiple-choice':
        return renderMultipleChoiceQuestion(question);
      case 'true-false':
        return renderTrueFalseQuestion(question);
      case 'code':
        return renderCodeQuestion(question);
      default:
        return (
          <View style={styles.errorContainer}>
            <Text style={styles.errorMessage}>Unknown question type</Text>
          </View>
        );
    }
  };

  // Render assessment progress with null safety
  const renderProgress = () => {
    if (!course || !course.assessment || !course.assessment.questions) {
      return null;
    }

    const totalQuestions = course.assessment.questions.length;
    const progressPercentage = ((currentQuestion + 1) / totalQuestions) * 100;

    return (
      <View style={styles.progressContainer}>
        <View style={styles.progressTrack}>
          <View
            style={[
              styles.progressFill,
              { width: `${progressPercentage}%` },
            ]}
          />
        </View>
        <Text style={styles.progressText}>
          {currentQuestion + 1} of {totalQuestions}
        </Text>
      </View>
    );
  };

  // Render timer
  const renderTimer = () => (
    <View style={styles.timerContainer}>
      <Ionicons name="time-outline" size={16} color="#EF4444" />
      <Text style={styles.timerText}>{formatTime(timeRemaining || 0)}</Text>
    </View>
  );

  // Render navigation buttons with null safety
  const renderNavigationButtons = () => {
    if (!course || !course.assessment || !course.assessment.questions) {
      return null;
    }

    const totalQuestions = course.assessment.questions.length;
    const currentQuestionData = course.assessment.questions[currentQuestion];
    const isAnswered = currentQuestionData && answers[currentQuestionData.id] !== undefined;

    return (
      <View style={styles.navigationContainer}>
        <TouchableOpacity
          style={[
            styles.navButton,
            styles.prevButton,
            currentQuestion === 0 && styles.disabledButton,
          ]}
          onPress={handlePrevQuestion}
          disabled={currentQuestion === 0}
        >
          <Ionicons name="chevron-back" size={20} color={currentQuestion === 0 ? "#CBD5E1" : "#64748B"} />
          <Text style={[
            styles.navButtonText,
            currentQuestion === 0 && styles.disabledButtonText,
          ]}>
            Previous
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={[
            styles.navButton,
            styles.nextButton,
            !isAnswered && styles.disabledButton,
          ]}
          onPress={handleNextQuestion}
          disabled={!isAnswered}
        >
          <Text style={[
            styles.navButtonText,
            styles.nextButtonText,
            !isAnswered && styles.disabledButtonText,
          ]}>
            {currentQuestion === totalQuestions - 1 ? 'Finish' : 'Next'}
          </Text>
          <Ionicons 
            name={currentQuestion === totalQuestions - 1 ? "checkmark" : "chevron-forward"} 
            size={20} 
            color={!isAnswered ? "#CBD5E1" : "#fff"} 
          />
        </TouchableOpacity>
      </View>
    );
  };

  // Render results screen
  const renderResults = () => {
    const isPassed = course?.assessment ? score >= course.assessment.passingScore : false;
    
    return (
      <ScrollView style={styles.resultsContainer}>
        <View style={styles.resultsContent}>
          <View style={styles.scoreCard}>
            <View style={[
              styles.scoreCircle,
              { backgroundColor: isPassed ? '#10B981' : '#EF4444' }
            ]}>
              <Text style={styles.scoreText}>{score}%</Text>
            </View>
            
            <Text style={styles.resultTitle}>
              {isPassed ? 'Congratulations! 🎉' : 'Keep Learning! 📚'}
            </Text>
            
            <Text style={styles.resultSubtitle}>
              {isPassed 
                ? `You passed the ${course?.title} assessment!`
                : `You need ${course?.assessment?.passingScore || 70}% to pass. Try again!`
              }
            </Text>
          </View>

          <View style={styles.resultsStats}>
            <View style={styles.statItem}>
              <Text style={styles.statValue}>{score}%</Text>
              <Text style={styles.statLabel}>Your Score</Text>
            </View>
            
            <View style={styles.statItem}>
              <Text style={styles.statValue}>{course?.assessment?.passingScore || 70}%</Text>
              <Text style={styles.statLabel}>Passing Score</Text>
            </View>
            
            <View style={styles.statItem}>
              <Text style={styles.statValue}>
                {course?.assessment ? Math.floor(((course.assessment.timeLimit * 60) - (timeRemaining || 0)) / 60) : 0}m
              </Text>
              <Text style={styles.statLabel}>Time Used</Text>
            </View>
          </View>

          <View style={styles.resultsActions}>
            {isPassed ? (
              <TouchableOpacity
                style={styles.continueButton}
                onPress={handleContinueToProgress}
              >
                <Text style={styles.continueButtonText}>Continue Learning</Text>
                <Ionicons name="arrow-forward" size={20} color="#fff" />
              </TouchableOpacity>
            ) : (
              <TouchableOpacity
                style={styles.retakeButton}
                onPress={handleRetakeAssessment}
              >
                <Text style={styles.retakeButtonText}>Retake Assessment</Text>
                <Ionicons name="refresh" size={20} color="#fff" />
              </TouchableOpacity>
            )}
            
            <TouchableOpacity
              style={styles.backButton}
              onPress={() => navigation.goBack()}
            >
              <Text style={styles.backButtonText}>Back to Courses</Text>
            </TouchableOpacity>
          </View>
        </View>
      </ScrollView>
    );
  };

  // Main render with null safety
  if (isLoading) {
    return (
      <SafeAreaView style={styles.safeArea}>
        <StatusBar barStyle="light-content" backgroundColor="#0e4e96" />
        
        <View style={styles.header}>
          <TouchableOpacity onPress={() => navigation.goBack()} style={styles.headerBackButton}>
            <Ionicons name="chevron-back" size={24} color="#fff" />
          </TouchableOpacity>
          <View style={styles.headerCenter}>
            <JobengLogo />
            <Text style={styles.headerTitle}>Skill Assessment</Text>
          </View>
          <View style={styles.headerButton} />
        </View>
        
        {renderLoading()}
      </SafeAreaView>
    );
  }

  if (error) {
    return (
      <SafeAreaView style={styles.safeArea}>
        <StatusBar barStyle="light-content" backgroundColor="#0e4e96" />
        
        <View style={styles.header}>
          <TouchableOpacity onPress={() => navigation.goBack()} style={styles.headerBackButton}>
            <Ionicons name="chevron-back" size={24} color="#fff" />
          </TouchableOpacity>
          <View style={styles.headerCenter}>
            <JobengLogo />
            <Text style={styles.headerTitle}>Skill Assessment</Text>
          </View>
          <View style={styles.headerButton} />
        </View>
        
        {renderError()}
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={styles.safeArea}>
      <StatusBar barStyle="light-content" backgroundColor="#0e4e96" />

      {/* Header */}
      <View style={styles.header}>
        <TouchableOpacity onPress={() => navigation.goBack()} style={styles.headerBackButton}>
          <Ionicons name="chevron-back" size={24} color="#fff" />
        </TouchableOpacity>
        <View style={styles.headerCenter}>
          <JobengLogo />
          <Text style={styles.headerTitle}>
            {showResults ? 'Assessment Results' : 
             showInstructions ? 'Assessment Instructions' : 
             'Skill Assessment'}
          </Text>
        </View>
        {assessmentStarted && !showResults && (
          <View style={styles.headerButton}>
            {renderTimer()}
          </View>
        )}
      </View>

      {/* Content */}
      <Animated.View 
        style={[
          styles.content,
          { 
            opacity: fadeAnim, 
            transform: [
              { translateY: slideAnim },
              { scale: scaleAnim }
            ] 
          }
        ]}
      >
        {showResults ? (
          renderResults()
        ) : showInstructions ? (
          renderInstructions()
        ) : (
          <>
            {/* Progress */}
            {renderProgress()}

            {/* Question */}
            <ScrollView style={styles.questionScrollView}>
              {renderQuestion()}
            </ScrollView>

            {/* Navigation */}
            {renderNavigationButtons()}
          </>
        )}
      </Animated.View>

      {/* Confirmation Modal */}
      <Modal
        visible={showConfirmModal}
        transparent
        animationType="fade"
        onRequestClose={() => setShowConfirmModal(false)}
      >
        <View style={styles.modalOverlay}>
          <View style={styles.confirmModal}>
            <Text style={styles.confirmTitle}>Submit Assessment?</Text>
            <Text style={styles.confirmMessage}>
              Are you sure you want to submit your assessment? You won't be able to change your answers after submission.
            </Text>
            
            <View style={styles.confirmButtons}>
              <TouchableOpacity
                style={styles.cancelButton}
                onPress={() => setShowConfirmModal(false)}
              >
                <Text style={styles.cancelButtonText}>Cancel</Text>
              </TouchableOpacity>
              
              <TouchableOpacity
                style={styles.submitButton}
                onPress={() => {
                  setShowConfirmModal(false);
                  handleAssessmentComplete();
                }}
              >
                <Text style={styles.submitButtonText}>Submit</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* Explanation Modal */}
      <Modal
        visible={showExplanation}
        transparent
        animationType="fade"
        onRequestClose={() => setShowExplanation(false)}
      >
        <View style={styles.modalOverlay}>
          <View style={styles.explanationModal}>
            <View style={styles.explanationHeader}>
              <Text style={styles.explanationTitle}>Explanation</Text>
              <TouchableOpacity onPress={() => setShowExplanation(false)}>
                <Ionicons name="close" size={24} color="#64748B" />
              </TouchableOpacity>
            </View>
            
            <Text style={styles.explanationText}>{currentExplanation}</Text>
            
            <TouchableOpacity
              style={styles.explanationCloseButton}
              onPress={() => setShowExplanation(false)}
            >
              <Text style={styles.explanationCloseButtonText}>Got it!</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#f8fafc',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingVertical: 16,
    backgroundColor: '#0e4e96',
    elevation: 4,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
  headerBackButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerCenter: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    marginHorizontal: 20,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#fff',
    marginLeft: 12,
  },
  headerButton: {
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    flex: 1,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    color: '#64748B',
    fontWeight: '500',
  },
  errorContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  errorTitle: {
    fontSize: 24,
    fontWeight: '600',
    color: '#EF4444',
    marginTop: 16,
    marginBottom: 8,
  },
  errorMessage: {
    fontSize: 16,
    color: '#64748B',
    textAlign: 'center',
    lineHeight: 24,
    marginBottom: 24,
  },
  errorButton: {
    backgroundColor: '#0e4e96',
    borderRadius: 12,
    paddingHorizontal: 24,
    paddingVertical: 12,
  },
  errorButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#fff',
  },
  instructionsContainer: {
    flex: 1,
  },
  instructionsContent: {
    padding: 20,
  },
  courseHeader: {
    backgroundColor: '#fff',
    borderRadius: 16,
    padding: 20,
    marginBottom: 20,
    elevation: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
  },
  courseInfo: {
    marginBottom: 16,
  },
  courseTitle: {
    fontSize: 24,
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: 4,
  },
  courseProvider: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 8,
  },
  courseDescription: {
    fontSize: 16,
    color: '#475569',
    lineHeight: 24,
  },
  courseMeta: {
    flexDirection: 'row',
    gap: 16,
  },
  metaItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  metaText: {
    fontSize: 12,
    color: '#64748B',
    fontWeight: '500',
  },
  portfolioSection: {
    marginBottom: 20,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1e293b',
    marginBottom: 12,
  },
  skillMatchCard: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    alignItems: 'center',
    elevation: 1,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 1,
  },
  skillMatchHeader: {
    alignItems: 'center',
    marginBottom: 8,
  },
  skillMatchPercentage: {
    fontSize: 32,
    fontWeight: '700',
    color: '#0e4e96',
  },
  skillMatchLabel: {
    fontSize: 14,
    color: '#64748B',
    fontWeight: '500',
  },
  skillMatchDescription: {
    fontSize: 12,
    color: '#94A3B8',
  },
  skillsSection: {
    marginBottom: 20,
  },
  skillsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  skillChip: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f1f5f9',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 6,
    gap: 4,
  },
  skillChipMatched: {
    backgroundColor: '#dcfce7',
  },
  skillChipText: {
    fontSize: 12,
    color: '#64748B',
    fontWeight: '500',
  },
  skillChipTextMatched: {
    color: '#166534',
  },
  assessmentDetails: {
    backgroundColor: '#fff',
    borderRadius: 16,
    padding: 20,
    marginBottom: 20,
    elevation: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
  },
  detailsGrid: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  detailItem: {
    alignItems: 'center',
    flex: 1,
  },
  detailLabel: {
    fontSize: 12,
    color: '#64748B',
    fontWeight: '500',
    marginTop: 8,
    marginBottom: 4,
  },
  detailValue: {
    fontSize: 16,
    color: '#1e293b',
    fontWeight: '600',
  },
  instructionsSection: {
    backgroundColor: '#fff',
    borderRadius: 16,
    padding: 20,
    marginBottom: 20,
    elevation: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
  },
  instructionsList: {
    gap: 16,
  },
  instructionItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 12,
  },
  instructionNumber: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: '#0e4e96',
    justifyContent: 'center',
    alignItems: 'center',
  },
  instructionNumberText: {
    fontSize: 12,
    color: '#fff',
    fontWeight: '600',
  },
  instructionText: {
    flex: 1,
    fontSize: 14,
    color: '#475569',
    lineHeight: 20,
  },
  startAssessmentButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#0e4e96',
    borderRadius: 12,
    paddingVertical: 16,
    gap: 8,
  },
  startAssessmentButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#fff',
  },
  progressContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 16,
    backgroundColor: '#fff',
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
  },
  progressTrack: {
    flex: 1,
    height: 8,
    backgroundColor: '#f1f5f9',
    borderRadius: 4,
    marginRight: 12,
  },
  progressFill: {
    height: '100%',
    backgroundColor: '#0e4e96',
    borderRadius: 4,
  },
  progressText: {
    fontSize: 14,
    color: '#64748B',
    fontWeight: '500',
  },
  timerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  timerText: {
    fontSize: 14,
    color: '#EF4444',
    fontWeight: '600',
  },
  questionScrollView: {
    flex: 1,
  },
  questionContainer: {
    padding: 20,
  },
  questionHeader: {
    marginBottom: 16,
  },
  questionMeta: {
    flexDirection: 'row',
    gap: 8,
  },
  categoryBadge: {
    backgroundColor: '#f1f5f9',
    borderRadius: 6,
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  categoryText: {
    fontSize: 10,
    color: '#64748B',
    fontWeight: '600',
  },
  difficultyBadge: {
    backgroundColor: '#fef3c7',
    borderRadius: 6,
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  difficultyText: {
    fontSize: 10,
    color: '#92400e',
    fontWeight: '600',
  },
  questionText: {
    fontSize: 18,
    color: '#1e293b',
    fontWeight: '600',
    lineHeight: 26,
    marginBottom: 20,
  },
  optionButton: {
    backgroundColor: '#fff',
    borderWidth: 2,
    borderColor: '#e2e8f0',
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    elevation: 1,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 1,
  },
  selectedOptionButton: {
    borderColor: '#0e4e96',
    backgroundColor: '#f8fafc',
  },
  optionContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  optionIndicator: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: '#f1f5f9',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  selectedOptionIndicator: {
    backgroundColor: '#0e4e96',
  },
  optionIndicatorText: {
    fontSize: 14,
    color: '#64748B',
    fontWeight: '600',
  },
  selectedOptionIndicatorText: {
    color: '#fff',
  },
  optionText: {
    flex: 1,
    fontSize: 16,
    color: '#475569',
    lineHeight: 22,
  },
  selectedOptionText: {
    color: '#1e293b',
    fontWeight: '500',
  },
  trueFalseContainer: {
    flexDirection: 'row',
    gap: 12,
  },
  trueFalseButton: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    borderWidth: 2,
    borderColor: '#e2e8f0',
    borderRadius: 12,
    paddingVertical: 16,
    gap: 8,
  },
  selectedTrueFalseButton: {
    borderColor: 'transparent',
  },
  trueButton: {
    backgroundColor: '#10B981',
  },
  falseButton: {
    backgroundColor: '#EF4444',
  },
  trueFalseText: {
    fontSize: 16,
    color: '#64748B',
    fontWeight: '600',
  },
  selectedTrueFalseText: {
    color: '#fff',
  },
  codeInputContainer: {
    backgroundColor: '#fff',
    borderWidth: 2,
    borderColor: '#e2e8f0',
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
  },
  codeInput: {
    fontSize: 14,
    color: '#1e293b',
    fontFamily: 'monospace',
    minHeight: 120,
    textAlignVertical: 'top',
  },
  explanationButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f1f5f9',
    borderRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: 12,
    marginTop: 16,
    gap: 4,
  },
  explanationButtonText: {
    fontSize: 12,
    color: '#0e4e96',
    fontWeight: '500',
  },
  navigationContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingVertical: 16,
    backgroundColor: '#fff',
    borderTopWidth: 1,
    borderTopColor: '#e2e8f0',
  },
  navButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 8,
    gap: 4,
  },
  prevButton: {
    backgroundColor: '#f1f5f9',
  },
  nextButton: {
    backgroundColor: '#0e4e96',
  },
  disabledButton: {
    backgroundColor: '#f8fafc',
  },
  navButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#64748B',
  },
  nextButtonText: {
    color: '#fff',
  },
  disabledButtonText: {
    color: '#CBD5E1',
  },
  resultsContainer: {
    flex: 1,
  },
  resultsContent: {
    padding: 20,
  },
  scoreCard: {
    backgroundColor: '#fff',
    borderRadius: 16,
    padding: 32,
    alignItems: 'center',
    marginBottom: 20,
    elevation: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
  },
  scoreCircle: {
    width: 120,
    height: 120,
    borderRadius: 60,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 20,
  },
  scoreText: {
    fontSize: 32,
    fontWeight: '700',
    color: '#fff',
  },
  resultTitle: {
    fontSize: 24,
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: 8,
    textAlign: 'center',
  },
  resultSubtitle: {
    fontSize: 16,
    color: '#64748B',
    textAlign: 'center',
    lineHeight: 22,
  },
  resultsStats: {
    flexDirection: 'row',
    backgroundColor: '#fff',
    borderRadius: 16,
    padding: 20,
    marginBottom: 20,
    elevation: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
  },
  statItem: {
    flex: 1,
    alignItems: 'center',
  },
  statValue: {
    fontSize: 20,
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: 4,
  },
  statLabel: {
    fontSize: 12,
    color: '#64748B',
    fontWeight: '500',
  },
  resultsActions: {
    gap: 12,
  },
  continueButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#10B981',
    borderRadius: 12,
    paddingVertical: 16,
    gap: 8,
  },
  continueButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#fff',
  },
  retakeButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#0e4e96',
    borderRadius: 12,
    paddingVertical: 16,
    gap: 8,
  },
  retakeButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#fff',
  },
  backButton: {
    alignItems: 'center',
    backgroundColor: '#f1f5f9',
    borderRadius: 12,
    paddingVertical: 16,
  },
  backButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#64748B',
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  confirmModal: {
    backgroundColor: '#fff',
    borderRadius: 16,
    padding: 24,
    width: '100%',
    maxWidth: 400,
  },
  confirmTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#1e293b',
    marginBottom: 12,
    textAlign: 'center',
  },
  confirmMessage: {
    fontSize: 16,
    color: '#64748B',
    lineHeight: 22,
    textAlign: 'center',
    marginBottom: 24,
  },
  confirmButtons: {
    flexDirection: 'row',
    gap: 12,
  },
  cancelButton: {
    flex: 1,
    alignItems: 'center',
    backgroundColor: '#f1f5f9',
    borderRadius: 8,
    paddingVertical: 12,
  },
  cancelButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#64748B',
  },
  submitButton: {
    flex: 1,
    alignItems: 'center',
    backgroundColor: '#0e4e96',
    borderRadius: 8,
    paddingVertical: 12,
  },
  submitButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#fff',
  },
  explanationModal: {
    backgroundColor: '#fff',
    borderRadius: 16,
    padding: 24,
    width: '100%',
    maxWidth: 400,
  },
  explanationHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  explanationTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1e293b',
  },
  explanationText: {
    fontSize: 16,
    color: '#475569',
    lineHeight: 24,
    marginBottom: 20,
  },
  explanationCloseButton: {
    alignItems: 'center',
    backgroundColor: '#0e4e96',
    borderRadius: 8,
    paddingVertical: 12,
  },
  explanationCloseButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#fff',
  },
});
